/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';
import {Function} from './function';

export class Reader extends BaseEntity {
  type: string;
  model: string;
  version: string;
  functions: Function[];
  maxAntennas: number;
  startPortNumber: number;
}
